<template>
  <svg class="compass" :class="{ 'compass--big': big, 'compass--bare': bare }" :viewBox="bare ? '-52 -52 104 104' : '-82 -62 164 124'" role="img" :aria-label="`The compass: ${described}`">
    <rect x="-50" y="-50" width="100" height="100" rx="8" class="compass__field" />
    <line x1="-50" y1="0" x2="50" y2="0" class="compass__axis" />
    <line x1="0" y1="-50" x2="0" y2="50" class="compass__axis" />
    <!--
      The four corners are the GOVERNMENTS, and they are drawn whether or
      not the town is in one: they used to be invisible until you arrived,
      so there was nothing on the graph to aim the dot at. Matt, 2026-09-20:
      "it's not really clear on the government graph where I need the dot to
      go in order to establish a government."
    -->
    <rect
      v-for="q in QUADS"
      :key="q.id"
      :x="q.x"
      :y="q.y"
      width="30"
      height="30"
      class="compass__quad"
      :class="{ 'compass__quad--on': government === q.id }"
    />
    <template v-if="big">
      <text
        v-for="q in QUADS"
        :key="`t${q.id}`"
        :x="q.x + 15"
        :y="q.y + 17"
        text-anchor="middle"
        class="compass__gov"
        :class="{ 'compass__gov--on': government === q.id }"
      >{{ q.short }}</text>
    </template>
    <template v-if="!bare">
    <text x="0" y="-53" text-anchor="middle" class="compass__label">Order</text>
    <text x="0" y="58" text-anchor="middle" class="compass__label">Liberty</text>
    <text x="-53" y="2" text-anchor="end" class="compass__label">Tradition</text>
    <text x="53" y="2" text-anchor="start" class="compass__label">Novelty</text>
    </template>
    <circle :cx="x * 10" :cy="y * 10" r="4.5" class="compass__dot" />
  </svg>
</template>

<script>
import {
  compassOf, governmentOf, describeCompass, GOVERNMENT_AT, GOVERNMENTS,
} from '@/engine/hall';

// Where each government's corner sits, in the compass's own units: a
// government needs GOVERNMENT_AT on BOTH axes, and the field runs to 5.
const EDGE = 50;
const IN = GOVERNMENT_AT * 10;
const QUADS = [
  { id: 'chiefdom', x: -EDGE, y: -EDGE },
  { id: 'empire', x: IN, y: -EDGE },
  { id: 'elders', x: -EDGE, y: IN },
  { id: 'assembly', x: IN, y: IN },
].map((q) => ({ ...q, short: GOVERNMENTS[q.id].name.replace('Council of ', '') }));

// The compass: where the town sits between Order and Liberty, Tradition
// and Novelty. Public (the table shows it too); the Hall's cards move it.
export default {
  name: 'Compass',
  // `bare`: just the square, no axis words - the Hall's header (2026-09-22).
  props: { civ: { type: Object, required: true }, big: { type: Boolean, default: false }, bare: { type: Boolean, default: false } },
  data() { return { QUADS }; },
  computed: {
    x() { return compassOf(this.civ).x; },
    y() { return compassOf(this.civ).y; },
    government() { return governmentOf(this.civ); },
    described() { return describeCompass(compassOf(this.civ)); },
  },
};
</script>
